import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Popover, List, ListItem, Divider } from '@material-ui/core';
import Button from '../Button';
export var TableActions = function TableActions(_ref) {
  var tableActions = _ref.tableActions,
      e2e = _ref.e2e;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var id = open ? 'simple-popover' : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, tableActions === null || tableActions === void 0 ? void 0 : tableActions.map(function (action) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: "table-actions-".concat(action.label)
    }, /*#__PURE__*/React.createElement(Button, _extends({}, e2e && {
      e2e: "".concat(e2e, "-table-actions-").concat(action.id || action.label)
    }, {
      "aria-describedby": action.label,
      variant: "contained",
      icon: action.icon,
      tooltip: action.label,
      dsOnClick: function dsOnClick(event) {
        var _action$onClick;

        action.listChildren && setAnchorEl(event.currentTarget);
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 ? void 0 : _action$onClick.call(action, event);
      }
    })), action.listChildren && /*#__PURE__*/React.createElement(Popover, {
      id: id,
      open: open,
      anchorEl: anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, /*#__PURE__*/React.createElement(List, {
      dense: true
    }, /*#__PURE__*/React.createElement(Divider, null), action.listChildren.map(function (child, idx) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: "table-action-child-".concat(child.label, "-").concat(idx)
      }, /*#__PURE__*/React.createElement(ListItem, {
        dense: true,
        button: true,
        onClick: child.onClick
      }, child.label), /*#__PURE__*/React.createElement(Divider, null));
    }))));
  }));
};

try {
  TableActions.__docgenInfo = {
    description: '',
    displayName: 'TableActions',
    methods: [],
    props: {
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: true,
        type: {
          name: 'any'
        }
      },
      tableActions: {
        defaultValue: null,
        description: '',
        name: 'tableActions',
        required: true,
        type: {
          name: 'any'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=TableActions.js.map